export var SurveyReadinessStatus;
(function (SurveyReadinessStatus) {
    SurveyReadinessStatus["COMPLETE"] = "COMPLETE";
    SurveyReadinessStatus["WARNING"] = "WARNING";
    SurveyReadinessStatus["ERROR"] = "ERROR";
})(SurveyReadinessStatus || (SurveyReadinessStatus = {}));
